import React from 'react';
import { withLoading } from '@front-activerse/common-components';
import UserMealEditMeal from './UserMealEditMeal';
import UniversalPlaceholder from '../../Layout/UniversalPlaceholder';
import { normalizeTrackerMeal } from '../../Tracker/helpers/normalizers';
import { TrackerMealProps } from '../../Tracker/types';

const UserMealDetailsContainer: React.FC<TrackerMealProps> = (props) => {
  const normalizedProps = normalizeTrackerMeal(props);
  sessionStorage.setItem('tracker_depth', '1');

  return <UserMealEditMeal key={normalizedProps.mealData.id} {...normalizedProps} />;
};

export default withLoading(UserMealDetailsContainer, UniversalPlaceholder);
